<template>
    <div>
        <div
            class="absolute top-6 right-6 flex h-10 w-10 cursor-pointer items-center justify-center bg-white rounded-full hover:text-red"
            :class="{ 'hidden' : open }"
            @click="openPopUp">
            <icon class="w-4 h-4 transition-transform transform fill-current"
                  name="expand-arrows" />
        </div>
        <Teleport to="body">
            <div class="z-50 fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-80 backdrop-blur-lg"
                v-show="open">
                <div class="relative">
                    <div class="absolute top-8 right-8 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-white text-white hover:text-red hover:bg-white"
                        @click="closePopUp">
                        <icon class="w-4 h-4 fill-current"
                              name="close" />
                    </div>
                </div>
                <div class="flex h-full w-full items-center justify-center">
                    <div class="w-full select-none py-24">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script lang="ts">
import Icon from './base/Icon.vue';
import Teleport from 'vue2-teleport';
export default {
    components: {
        Teleport,
        Icon
    },
    data() {
        return {
            open: false
        };
    },
    methods: {
        openPopUp() {
            document.body.classList.toggle('overflow-hidden', true);
            this.open = true;
        },
        closePopUp() {
            document.body.classList.toggle('overflow-hidden', false);
            this.open = false;
        }
    }
};
</script>
